module.exports = __webpack_public_path__ + "static/img/safeManage.ad3951d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safeManage.png
// module id = zhmG
// module chunks = 1